// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Walker from '../../../Texas/data/counties/Walker.geo.json'
import Montgomery from '../../../Texas/data/counties/Montgomery.geo.json'
import Austin from '../../../Texas/data/counties/Austin.geo.json'
import Waller from '../../../Texas/data/counties/Waller.geo.json'
import Harris from '../../../Texas/data/counties/Harris.geo.json'
import Colorado from '../../../Texas/data/counties/Colorado.geo.json'
import Fort_Bend from '../../../Texas/data/counties/Fort_Bend.geo.json'
import Wharton from '../../../Texas/data/counties/Wharton.geo.json'
import Matagorda from '../../../Texas/data/counties/Matagorda.geo.json'

const counties = {
  Walker,
  Montgomery,
  Austin,
  Waller,
  Harris,
  Colorado,
  Fort_Bend,
  Wharton,
  Matagorda
}

export default counties
